import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/services/api.service';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import { FormValue } from 'src/services/FormValue';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.css']
})
export class ComplaintComponent {

  complaintCategory:any;
  complaintForm:FormGroup;
  showMessage:boolean = false;
  constructor(private formBuilder: FormBuilder,
              private apiService: ApiService,
              private toastService: ToastService) {
      this.complaintForm = this.initializeForm();
      this.findComplaintCategory();
  }
  findComplaintCategory(){
    this.apiService.get_("/complaint/find/all/category").subscribe((response:any) =>{
      this.complaintCategory = response.data;
    });
  }

  initializeForm(){
    return this.complaintForm = this.formBuilder.group({
      'id':[''],
      'name': ['', [Validators.required]],
      'email': ['', [Validators.required, Validators.email]],
      'phone': ['', [Validators.required]],
      'description': ['', [Validators.required]],
      'complaintCategory': this.formBuilder.group({
        'id':['', [Validators.required]],
        'name':[''],
        'description':['']
      })
    });
  }

  save(){
    this.showMessage = false;
    let request = FormValue.get(this.complaintForm);
    request["complaintCategory"] = this.complaintCategory[request["complaintCategory"]["id"]];
    this.apiService.post_("/complaint/save", request)
    .subscribe((response:any) =>{
      if (response.success && response.status=="OK"){
        this.complaintForm.reset();
        this.showMessage = true;
        this.toastService.showSuccess("Your complaint has been logged successfully");
      }
    });
  }

}
